/**
 * Extra indexed fields on userDirectory so presenter search is not limited to
 * "full displayName starts with query" (which misses surnames: "Sophie Buntinx" + "bu").
 */

export interface UserDirectoryNameSearchFields {
  dirNameToken0: string | null;
  dirNameToken1: string | null;
  dirNameTokenLast: string | null;
}

export function buildUserDirectoryNameSearchFields(displayName: string): UserDirectoryNameSearchFields {
  const parts = String(displayName || '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) {
    return { dirNameToken0: null, dirNameToken1: null, dirNameTokenLast: null };
  }
  if (parts.length === 1) {
    const t = parts[0];
    return { dirNameToken0: t, dirNameToken1: t, dirNameTokenLast: t };
  }
  return {
    dirNameToken0: parts[0],
    dirNameToken1: parts[1],
    dirNameTokenLast: parts[parts.length - 1]
  };
}
